import { COOKIE_OPTIONS } from '@/utils/constants/cookies'

type TCountryScopedCard = {
  visibleInCountries?: string[]
}

export function useFilterVisibilityByCountry<TCard extends object>(getCards: () => TCard[] | undefined) {
  const countryCookie = useCookie<string | undefined>('country', { ...COOKIE_OPTIONS })

  const isVisibleInCountry = (card: TCard) => {
    const visibleInCountries = (card as TCountryScopedCard).visibleInCountries

    if (!visibleInCountries || visibleInCountries.length === 0 || !countryCookie.value) return true

    return visibleInCountries.includes(countryCookie.value)
  }

  return computed(() => (getCards() ?? []).filter((card) => isVisibleInCountry(card)))
}
